import {Injectable} from "@angular/core";
import {HttpService} from "../http/http.service";
import {MembershipApplication, Question, ProductsMessage} from "./membership-application";
import { Observable } from "rxjs";

@Injectable()
export class MembershipApplicationService {
  private url = '/api/applications/membership';

  constructor(private httpService: HttpService) {
  }

  getQuestions() : Observable<Question[]>{
    return this.httpService.get(`${this.url}/questions`)
      .map(res => res.json() as Question[])
  }

  getProducts() : Observable<ProductsMessage>{
    return this.httpService.get(`/api/pages/membership/products`)
      .map(res => res.json() as ProductsMessage)
  }

  apply(application: MembershipApplication) {
    return this.httpService.post(`${this.url}/apply`, application)
      .map(res => res.json() as MembershipApplication);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/membership-application/membership-application.service.ts